<template>
    <div class="container">
        <v-title :breadcrumb="{label: 'Integrations', route: {name: 'integrations'}}">
            Integrations
        </v-title>
        <div class="grid">
            <div class="grid-item grid-item-primary">
                <div class="grid">
                    <div class="grid-item grid-item-full">
                        <div class="tile position-relative">
                            <v-inline-loader v-if="isLoading"/>
                            <div class="tile-title">
                                <div class="tile-title-primary">
                                    <h2 class="stack-m">Apps</h2>
                                    <p class="text-muted no-margin-bottom">A list of all available integrations</p>
                                </div>
                            </div>
                            <div class="tile-content">
                                <ul class="list list-group list-relaxed list-divided">
                                    <li
                                        v-for="(integration, index) in integrations"
                                        :key="index"
                                        class="list-item align-items-center">
                                        <integrations-logo :integration="integration"/>
                                        <div>
                                            <h2>{{integration.displayLabel}}</h2>
                                            <p>{{integration.summary}}</p>
                                        </div>
                                        <div
                                            v-if="integration.implemented && $auth.$pages['integration-view'].isAllowed"
                                            class="no-flex">
                                            <router-link
                                                v-if="integration.hasConfigurations"
                                                :to="{name: 'integration-view', params: {service: integration.service}}"
                                                class="btn btn-link">{{integration.count}} {{'configuration' | pluralize(integration.count)}}</router-link>
                                            <router-link
                                                v-else
                                                :to="{name: 'integration-add', params: {service: integration.service}}"
                                                class="btn btn-link">Start</router-link>
                                        </div>
                                        <v-fake-door
                                            v-else
                                            :config="integration.service"
                                            class="no-flex">
                                            <r-button type="link">
                                                Start
                                            </r-button>
                                        </v-fake-door>
                                    </li>
                                </ul>
                            </div>
                            <div class="tile-content">
                                <p>
                                    Don't see what you're looking for?
                                    <a target="_blank" href="https://www.rebilly.com/contact/">
                                        Contact Us
                                    </a>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="grid-item grid-item-secondary">
                <integrations-read-more/>
            </div>
        </div>
    </div>
</template>

<script>
    import vTitle from '@/components/v-title';
    import {
        vIcon,
    } from '@/components/form';
    import vFakeDoor from '@/components/v-fake-door';
    import vNoContent from '@/components/v-no-content';
    import vInlineLoader from '@/components/v-inline-loader';
    import IntegrationsReadMore from '@/modules/integrations/components/integrations-read-more';
    import IntegrationsLogo from '@/modules/integrations/components/integrations-logo';
    import IntegrationModel from '@/common/models/integration-model';

    export default {
        name: 'integrations',
        components: {
            vTitle,
            vIcon,
            vNoContent,
            vFakeDoor,
            vInlineLoader,
            IntegrationsReadMore,
            IntegrationsLogo,
        },
        data() {
            const services = [
                ...Object.values(IntegrationModel.Services),
                ...Object.values(IntegrationModel.FutureServices),
            ];
            const integrations = services.reduce((result, service) => {
                result[service] = new IntegrationModel({service});
                return result;
            }, {});

            return {
                isLoading: false,
                integrations,
                customIntegrations: null,
            };
        },
        methods: {
            async fetchData() {
                this.isLoading = true;
                try {
                    const params = {};
                    const {items} = await this.$api(({integrations}) => integrations.getAll(params));
                    items.forEach((item) => {
                        const integration = new IntegrationModel(item.fields);
                        this.integrations[integration.service] = integration;
                    });
                } catch (error) {
                    this.$toast.fromError(error);
                } finally {
                    this.isLoading = false;
                }
            },
        },
        mounted() {
            this.fetchData();
        },
    };
</script>
